import React from 'react';
import { Link, useHistory, useRouteMatch } from "react-router-dom";
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import { Avatar, Toolbar } from '@material-ui/core';
import PortfolioList from "../../../components/PortfolioList";
import TransactionAddDialog from "../../../components/TransactionAddDialog";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import { useStyles } from './style';
import * as Image from '../img'
import Hidden from '@material-ui/core/Hidden';
import TinkoffImportUpdate from "../../../components/TinkoffImportUpdate";
import {Grid} from "@material-ui/core";
import Stack from '@mui/material/Stack';


function Header() {
    const history = useHistory();
    const classes = useStyles();
    const { path, url } = useRouteMatch();
    const [value, setValue] = React.useState(0);

    const first_name = localStorage.getItem('first_name');
    const last_name = localStorage.getItem('last_name');

    const handleChange = (event, newValue) => {
        setValue(newValue);
    };


    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    function handelUnlogClick() {
        localStorage.clear();
        window.location.href = "/login";
        //history.push('/login')
    }
//onClick={handelUnlogClick}
    return (
        <AppBar position="static" className={classes.root}>
            <Toolbar className={classes.toolbar}>
                <Image.Logo />
                <Hidden smDown>
                <Tabs value={value} onChange={handleChange} aria-label="nav tabs example" >
                    <Tab label="Портфель" className={classes.link} to={"/portfolio"} component={Link} />
                    <Tab label="Аналитика" className={classes.link} to={"/analytics"} component={Link} />
                    <Tab label="Сделки" className={classes.link} to={"/transactions"} component={Link} />
                </Tabs>
                </Hidden>
                <Stack direction="row" justifyContent="flex-end">
                    <TinkoffImportUpdate/>
                    <PortfolioList noWrap />
                </Stack>

                <Hidden smDown>
                <TransactionAddDialog />
                </Hidden>
                <Avatar src="" aria-controls="simple-menu" aria-haspopup="true" onClick={handleClick}>{first_name && first_name[0]}</Avatar>
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                >
                    <MenuItem disabled>{first_name} {last_name}</MenuItem>
                    <MenuItem to='/events' onClick={handleClose} component={Link}>События</MenuItem>
                    <MenuItem to='/settings/tokens' onClick={handleClose} component={Link}>AI-интеграции</MenuItem>
                    <MenuItem onClick={handelUnlogClick}>Выход</MenuItem>
                </Menu>
            </Toolbar>
        </AppBar>
    );
}

export default Header
